module.exports = __webpack_public_path__ + "img/LT.60ce52ef.svg";